import { render, staticRenderFns } from "./runOpenai.vue?vue&type=template&id=3f2d93d7"
import script from "./runOpenai.vue?vue&type=script&lang=js"
export * from "./runOpenai.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports